import { Component, Input } from '@angular/core';
import { ngClassObject } from '../../../shared/types';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @Input() level: 'primary' | 'secondary' | 'tertiary' | 'quaternary' =
    'primary';
  @Input() iconUrl!: string;
  @Input() title!: string;
  @Input() firstDescription!: string;
  @Input() secondDescription!: string;
  @Input() smallWidth!: boolean;
  @Input() mediumWidth!: boolean;

  get classes(): ngClassObject<string> {
    return {
      'primary-background': this.level === 'primary',
      'secondary-background': this.level === 'secondary',
      'tertiary-background': this.level === 'tertiary',
      'quaternary-background': this.level === 'quaternary',
    };
  }
  get whiteContainerBorder(): ngClassObject<string> {
    return {
      'primary-border': this.level === 'primary',
      'secondary-border': this.level === 'secondary',
      'tertiary-border': this.level === 'tertiary',
      'quaternary-border': this.level === 'quaternary',
    };
  }
}
